// extracted by mini-css-extract-plugin
module.exports = {"container":"_3nrA5hKeRR1_7AvKqGcuvG","visible":"_1wOJR_R6tGKmUZB-ol_ZlI","cancelBtn":"_2S-kzL8ZDRHlUa_tgRzKzF","icon":"_1LRDvv5YDQD6jkKDKnibO3","saveBtn":"_3BdqERJyKTRPgf-1a-HC8N"};